<template>
	<div class="box">
		<div class="box_top">
			<div class="left">
				<img src="@/assets/image/logoCN.png" @click="goHome" />
			</div>
			<div class="right">
				<div class="langs">
					<div @click="changeLangs('zh')" class="more1">中文版 </div>
					<span>|</span>
					<div @click="changeLangs('en')" class="more1">English</div>
				</div>
				<div class="box_title" v-if="dataList.length > 0">
					<div v-for="(item, index) in dataList" :key="index" class="box_item" @mouseenter="changeTab(index)"
						@mouseleave="leave">
						<span @click="goPath(11, item)">{{ item.title }}</span>
						<!-- <div class="moust" v-show="item.children.length > 0 && index == Index" id="moust"
							v-if="item.children"> -->
						<div class="moust" v-show="item.children.length > 0 && index == Index" id="moust"
							v-if="item.children.length > 0">
							<img src="@/assets/image/sj2.png">
							<div style="margin-top: 10px;">
								<div v-for="(item1, index1) in item.children" :key="index1"
									@mousemove="showTabInfo(index1)" @click="goPath(index1, item1)"
									@mouseleave="showTab = false"
									:class="showTab && index1 == IndexValue ? 'un_name' : 'name'">
									{{ item1.title }}
								</div>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;" @mouseleave="leave">
						<img src="@/assets/image/office.jpg" style="width: 90px;" @mouseenter="changeTab(9)" />
						<div class="moust-list" v-show="Index == 9">
							<img src="@/assets/image/sj2.png">
							<div class="name_box">
								<a v-for="(item, index) in imageData" :key="index" :href="item.webLink" v-once
									@mousemove="showTabInfo(index)" @mouseleave="showTab = false" target="_blank"
									:class="showTab && index == IndexValue ? 'un_name' : 'name'">
									{{ item.title }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	tree
} from '@/api/apis'

export default {
	name: 'NavBar',
	props: {
		num: Number
	},
	data() {
		return {
			showTab: false,
			Index: '',
			IndexValue: 0,

			dataList: [
				// {
				// 	title: '网站首页',
				// 	webLink: 'Home'
				// },
				// {
				// 	title: '走近城投',
				// 	webLink: 'contentView',
				// 	children: [{
				// 		title: '集团简介',
				// 		webLink: 'contentView'
				// 	},
				// 	{
				// 		title: '企业架构',
				// 		webLink: 'contentView'
				// 	},
				// 	{
				// 		title: '企业荣誉',
				// 		webLink: 'contentView'
				// 	}]
				// },
				// {
				// 	title: '新闻在线',
				// 	webLink: 'news',
				// 	children: [{
				// 		title: '集团动态',
				// 		webLink: 'news'
				// 	},
				// 	{
				// 		title: '项目动态',
				// 		webLink: 'news'
				// 	}]
				// },
				// {
				// 	title: '项目中心',
				// 	webLink: 'contentView/map',
				// 	children: [{
				// 		title: '项目地图',
				// 		webLink: 'contentView/map'
				// 	},
				// 	{
				// 		title: '项目简介',
				// 		webLink: 'contentView/map'

				// 	}]
				// },
				// {
				// 	title: '经营管理',
				// 	webLink: 'operate',
				// 	children: [{
				// 		title: '物业管理',
				// 		webLink: 'operate'
				// 	},
				// 	{
				// 		title: '资产经营',
				// 		webLink: 'operate'
				// 	}, {
				// 		title: '安全生产',
				// 		webLink: 'operate'
				// 	}]
				// },
				// {
				// 	title: '党群工作',
				// 	webLink: 'political',
				// 	children: [{
				// 		title: '党建动态',
				// 		webLink: 'political'
				// 	},
				// 	{
				// 		title: '党风廉政',
				// 		webLink: 'political'
				// 	}, {
				// 		title: '群团活动',
				// 		webLink: 'political'
				// 	}, {
				// 		title: '城投信箱',
				// 		webLink: 'political'
				// 	}]
				// },
				// {
				// 	title: '企业文化',
				// 	webLink: 'corporate',
				// 	children: [{
				// 		title: '团队风采',
				// 		webLink: 'corporate'
				// 	},
				// 	{
				// 		title: '城投课堂',
				// 		webLink: 'corporate'
				// 	}]
				// },
				// {
				// 	title: '联系我们',
				// 	webLink: 'callus',
				// 	children: [{
				// 		title: '人力资源',
				// 		webLink: 'callus'
				// 	},
				// 	{
				// 		title: '招聘信息',
				// 		webLink: 'callus'
				// 	},
				// 	{
				// 		title: '路线指引',
				// 		webLink: 'callus'
				// 	}]
				// },

			],
			imageData: [
				// {
				// 	title: 'OA内网',
				// 	webLink: 'http://192.168.1.244/'
				// },
				// {
				// 	title: 'OA外网',
				// 	webLink: 'http://58.211.65.106:81/'
				// },
				// {
				// 	title: 'ERP内网',
				// 	webLink: 'http://192.168.1.247/'
				// },
				// {
				// 	title: 'ERP外网',
				// 	webLink: 'http://58.211.65.106:90/'
				// },
				// {
				// 	title: '企业邮箱',
				// 	webLink: 'http://mail.ksccid.com/'
				// },
				// {
				// 	title: '政府OA',
				// 	webLink: 'http://dns.ks.gov.cn/logon.aspx'
				// }
			],
			list: [],
			treeList: []
		}
	},
	created() {
		this.$i18n.locale = 'zh'
	},
	mounted() {
		this.getTree()

	},
	methods: {
		changeTab(value) {
			this.Index = value
		},
		leave() {
			this.Index = ''
		},
		changeLangs(value) {
			console.log("value", value)
			if (value === 'zh') {
				this.$i18n.locale = 'zh'
				// localStorage.setItem('lang', 'en') // en表示英文，zh表示中文，可根据自己喜好设定，尽量通俗易懂
			} else {
				this.$i18n.locale = 'en'
				// localStorage.setItem('lang', 'zh')
				this.$nextTick(() => {
					this.$router.push({
						name: 'homeEn'
					})
				})
			}
			location.replace(location) //刷新网页

		},
		goPath(index, item) {
			console.log("name", item.webLink)
			if (index == 11) {
				index = 0
			}

			if (item.title == '项目简介') {
				this.$router.push({
					name: item.webLink,
					query: {
						index: '10'
					}
				})
			} else if (item.webLink) {
				this.$router.push({
					name: item.webLink,
					query: {
						index: index.toString()
					}
				})
			}

			// this.$store.commit('setValue', item.title)
		},
		goHome() {
			this.$router.push({
				name: 'Home',
			})
			location.reload()

		},
		showTabInfo(index) {
			this.IndexValue = index
			this.showTab = true
		},
		getTree() {
			let params = {
				pid: '',
				searchStatus: 1
			}
			var that = this
			tree(params).then(res => {
				// console.log('tree', res.data)
				if (res.code == 1) {
					that.dataList = res.data[0].children
					that.imageData = res.data[1].children
					localStorage.setItem("childen", JSON.stringify(res.data[0].children))
					localStorage.setItem("other_childen", JSON.stringify(res.data[2].children))

					console.log('tree1', that.dataList)

				}
			})

		}
	}
}
</script>

<style scoped lang="scss">
.box {
	position: relative;
	width: 100%;
	height: 100px;

	.box_top {
		width: 1100px;
		height: 100px;
		margin: 0 auto;
		display: flex;

		.left {
			padding-top: 11px;
			// margin-left: 30px;
		}

		.right {
			position: relative;
			width: 950px;

			.langs {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				margin-right: 20px;

				span {
					margin: 0px 3px;
					line-height: 25px;
					font-size: 12px;
					// font-family: 微软雅黑;
					color: rgb(102, 102, 102);
					cursor: pointer;
				}
			}

			.box_title {
				height: 50px;
				margin-top: 25px;
				display: flex;
				align-items: center;

				img {
					cursor: pointer;
				}

				.box_item {
					position: relative;
					display: inline-block;
					width: 100px;
					line-height: 50px;
					// font-family: "微软雅黑";
					font-size: 16px;
					font-weight: bold;
					color: #333333;
					text-align: center;
					cursor: pointer;
					transition: transform 0.3s ease; //下拉动画
					transform-origin: top; // 起始位置
				}

				.box_item:hover #moust {
					display: block;
					transform: scaleY(1);
				}
			}

			.moust-list {
				background-color: #315565;
				position: absolute;
				z-index: 9999;
				width: 170px;
				opacity: 0.8;
				color: #fff;
				font-size: 14px;
				right: -30px;

				img {
					position: absolute;
					top: 0;
					left: 74px;
				}

				.name_box {
					margin-top: 10px;
					display: flex;
					flex-wrap: wrap;
					text-align: center;

					.name {
						height: 35px;
						line-height: 25px;
						width: 50%;
					}

					.un_name {
						height: 35px;
						line-height: 25px;
						width: 50%;
						background-color: #7C5845;
					}

					>a {
						display: block;
						width: 90px;
						font-size: 14px;
						color: #fff;
					}
				}

			}


		}

	}

	.moust {
		background-color: #315565;
		position: absolute;
		z-index: 9999;
		width: 90px;
		opacity: 0.8;
		color: #fff;
		font-size: 14px;


		img {
			position: absolute;
			top: 0;
			left: 34px;
		}

		.name {
			height: 35px;
			line-height: 25px;
		}

		.un_name {
			background-color: #7C5845;
			height: 35px;
			line-height: 25px;
		}
	}

	.more1 {
		line-height: 25px;
		font-size: 12px;
		// font-family: 微软雅黑;
		color: rgb(102, 102, 102);
		cursor: pointer;
	}

	.more1:hover {
		color: #F39801;
	}

}
</style>
